import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { RouteConstants } from "utils/constants";
//#endregion
//#region components
import { PageLayouts, RouteBreadCrumb } from "components/common";
import CreateQuotation from "./createQuotation";
import { useQuotesService } from "serviceHooks";
import { useLocation } from "react-router-dom";
import useQuotationPermissions from "./usePemissions";
//#endregion

const CreateQuotationContainer: React.FC = () => {
  const quotesService = useQuotesService();
  const [loading, setLoading] = React.useState(true);
  const [templateQuotation, setTemplateQuotation] = React.useState<WintSuperkollAPIModel.Quotation>();

  const queryParams = new URLSearchParams(useLocation().search);
  const quotationSerialNumber = React.useRef<number>(
    Number(queryParams.get(RouteConstants.QuotationQueryParams.QuotationTemplate) ?? 0)
  );

  const { canCreateQuotations } = useQuotationPermissions();

  React.useEffect(() => {
    if (quotationSerialNumber.current > 0) {
      loadQuotation(quotationSerialNumber.current);
    } else {
      setTemplateQuotation(undefined);
      setLoading(false);
    }
  }, [quotationSerialNumber.current]);

  const loadQuotation = (serialNumber: number) => {
    quotesService
      .getCopiedQuotation(serialNumber)
      .then((res) => {
        setTemplateQuotation(res);
      })
      .finally(() => setLoading(false));
  };

  return (
    <PageLayouts.EntityFullScreen
      id={0}
      entityKey={`quotation`}
      navigation={<RouteBreadCrumb current={TranslationKeys.Quotation.CreateQuotation} showHome />}
      hasPermissions={canCreateQuotations}
      hideSpeedDial
    >
      <CreateQuotation quotation={templateQuotation} loading={loading} />
    </PageLayouts.EntityFullScreen>
  );
};

export default CreateQuotationContainer;
